import { t } from "i18next";    

export const useLegendDialogTableData = () => {
    const headers = [
        t("fieldName"),
        t("description"),
    ];

    const labelNames = [
        "leads.table.leadCount",
        "leads.table.clientCount",
        "leads.table.lastClientCount",
        "leads.table.leadFiaskoCount",
        "leads.table.leadMistakeCount",
        "leads.table.offerFiaskoCount",
        "leads.table.contactCount",
        "leads.table.clientContactCount",
        "leads.table.clientBookingCount",
        "leads.table.clientAggrementCount",
        "leads.table.aggrementCount"
    ]

    const rows = []
    for (let i=0; i < labelNames.length; i++) {
        const label = labelNames[i]
        rows.push(
            { rowId: i, data:[t(`${label}`), t(`${label}Description`)]})
    }


    return {headers, rows}
};
